/*
 * assets/ce-reveal.js — die Ankunft des Motion-Systems.
 *
 * Setzt .is-in auf jedes Element mit .ce-reveal oder .ce-reveal-group, sobald es
 * in den Blick geraet. Alles Weitere — Weg, Dauer, Kurve, Staffelung — steht in
 * theme.css, Abschnitt 5.7. Diese Datei entscheidet ausschliesslich WANN.
 *
 * WARUM KEIN CUSTOM ELEMENT
 * -------------------------
 * Alle anderen Verhaltensdateien des Themes sind Custom Elements auf CEElement,
 * weil ihr Verhalten einer Sektion gehoert und mit ihr entsteht und vergeht
 * (02-theme-architecture.md §3.4). Die Ankunft gehoert keiner Sektion — sie ist
 * eine Eigenschaft der Seite, und ein Wrapper-Element um jede Kachelgruppe waere
 * ein zusaetzlicher Kasten in Grid- und Flex-Kontexten, also eine Layout-
 * Aenderung fuer eine reine Verhaltensfrage. Deshalb ein Modul mit genau einem
 * Observer fuer die ganze Seite.
 *
 * Der Preis dafuer ist der Theme-Editor: ohne connectedCallback meldet sich eine
 * neu gerenderte Sektion nicht von selbst. Dafuer steht unten das einzige
 * shopify:section:load des Themes — und zwar nur in designMode, fuer Besucher
 * haengt der Listener nie.
 *
 * WARUM EINMAL UND DANN NIE WIEDER
 * --------------------------------
 * Nach dem Auftritt wird das Element abgemeldet. Ein Element, das beim
 * Zurueckscrollen wieder verschwindet, liest sich nicht als Bewegung, sondern
 * als Fehler — und ein Observer, der nichts mehr zu tun hat, soll auch nichts
 * mehr beobachten.
 */

const SELECTOR = '.ce-reveal, .ce-reveal-group';

/* -12 % heisst: der Auftritt beginnt, wenn das Element 12 % der Fensterhoehe
   ueber der Unterkante steht, nicht schon an der Kante selbst. Sonst laeuft die
   Bewegung genau dort, wo das Auge sie am schlechtesten sieht. */
const ROOT_MARGIN = '0px 0px -12% 0px';

const root = document.documentElement;

if (!('IntersectionObserver' in window)) {
  /* Kein Observer, kein Ausloeser — der Ruhezustand haette keinen Ausgang.
     Also nehmen wir ihn weg, statt die Seite leer zu lassen. */
  root.classList.remove('ce-js');
} else {
  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }
    },
    { rootMargin: ROOT_MARGIN, threshold: 0 }
  );

  const scan = (scope) => {
    for (const el of scope.querySelectorAll(SELECTOR)) {
      if (!el.classList.contains('is-in')) io.observe(el);
    }
  };

  scan(document);

  /* Die Quittung fuer den Riegel im <head>: ab hier nimmt das Inline-Skript
     .ce-js nicht mehr zurueck. Erst NACH dem ersten scan(), damit ein Fehler
     darin noch in den Ruecklauf faellt. */
  root.classList.add('ce-reveal-ready');

  /* Fuer Markup, das NACH dem Seitenaufbau ankommt: die Empfehlungen der
     Produktseite tauschen ihr Raster gegen Shopifys Antwort. Neue Karten
     traegen .ce-reveal, kennt der Observer sie nicht, bleiben sie bei
     opacity 0 — die Sektion waere still leer. Das Skript, das den Tausch
     macht, meldet den Bereich deshalb hier an. Nur in designMode kam bisher
     etwas nach; das bleibt, dies ist der zweite Weg fuer den Laden. */
  if (window.CE) window.CE.reveal = scan;

  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (e) => scan(e.target));
  }
}
